import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeActivityStatusProps } from '../types/interfaces'

import { ActivityStatus } from '@brighterly/lib-core-types/booking/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeActivityStatusOptions {
  props: BadgeActivityStatusProps
}

interface BadgeActivityStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const STATUS_COLORS: Partial<Record<ActivityStatus, AppBadgeColor>> = {
  [ActivityStatus.Web]: 'emerald',
  [ActivityStatus.Online]: 'emerald',
  [ActivityStatus.Waiting]: 'blue',
  [ActivityStatus.PreRoom]: 'indigo',
  [ActivityStatus.Start]: 'slate',
  [ActivityStatus.Offline]: 'red',
  [ActivityStatus.Never]: 'slate',
}

export const useBadgeActivityStatus = ({ props }: BadgeActivityStatusOptions): BadgeActivityStatusReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<ActivityStatus>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getLists?.booking.activity_status,
  })
}
